"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TextUtils_1 = require("./TextUtils");
var Utils_1 = require("./Utils");
var XmlUtils = /** @class */ (function () {
    function XmlUtils() {
    }
    XmlUtils.GetNodeAttr = function (node, AttrName, sDefault) {
        if (sDefault === void 0) { sDefault = ""; }
        return this.getNodeAttr(node, AttrName, sDefault);
    };
    XmlUtils.getNodeAttr = function (node, AttrName, sDefault) {
        if (sDefault === void 0) { sDefault = ""; }
        if (node == null) {
            return sDefault;
        }
        var s = node.getAttrValue(AttrName);
        if (TextUtils_1.default.isEmpty(s)) {
            return sDefault;
        }
        else {
            return s;
        }
    };
    XmlUtils.getValuesByConditions = function (map, parent, defaultValue) {
        var _this = this;
        if (defaultValue === void 0) { defaultValue = ""; }
        if (parent == null) {
            map.put(Utils_1.Utils.MACRO_DEFAULT, defaultValue);
            return;
        }
        parent.getChildNodes().forEach(function (node) {
            _this.getNodeAttr(node, "conditions", Utils_1.Utils.MACRO_DEFAULT).split(";").forEach(function (s) { return map.put(s, node.getAttrValue(Utils_1.Utils.PROP_ATTR_NAME)); });
        });
        ;
        // for (let node in list) {
        //    const conditions = this.getNodeAttr(node, "conditions", Utils.MACRO_DEFAULT).split(";");
        //     for (l s : conditions) {
        //         map.put(s, GetNodeAttr(node, "name"));
        //     }
        // }
        if (!map.containsKey(Utils_1.Utils.MACRO_DEFAULT)) {
            map.put(Utils_1.Utils.MACRO_DEFAULT, defaultValue);
        }
    };
    return XmlUtils;
}());
exports.default = XmlUtils;

//# sourceMappingURL=XmlUtils.js.map
